import React, { useEffect, useState } from "react"
import { Drawer, Table, Typography } from "antd"
import { UnorderedListOutlined } from "@ant-design/icons"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { endDate, startDate } from "../../Orders/Helpers/TableDetails"
import { OrderAndPrefix } from "../../Orders/Helpers/OrderAndPrefix"
import ShowImageWithLink from "../../Orders/Helpers/ShowImageWithLink"

const { Text, Link } = Typography

export default function OrderHistory({ price }) {
  const [open, setOpen] = useState(false)
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open && price?.id) {
      // Check if price and price.id are available before making the query
      setLoading(true)
      // Ref for orders
      const ordersRef = collection(db, "orders")

      // Construct the query
      const activeQ = query(
        ordersRef,
        where("selectedProduct.id", "==", price.id),
        where("orderStatus", "==", 7),
      )

      // Subscribe to the query
      const unsubscribe = onSnapshot(activeQ, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ ...doc.data(), id: doc.id })
        })

        setOrders(results)
        setLoading(false)
      })

      // Cleanup function to unsubscribe from the listener when component unmounts or dependencies change
      return () => unsubscribe()
    }
  }, [open, price])

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  const tableColumns = [
    {
      title: "Order Number",
      dataIndex: "orderNumber",
      render: (value, record) => {
        return OrderAndPrefix(record)
      },
    },
    {
      title: "Created",
      dataIndex: "amountCreated",
    },
    {
      title: "Machine",
      dataIndex: ["selectedProduct", "machine"],
    },
    {
      title: "Manufacturer",
      dataIndex: ["manufacturer", "company"],
    },
    {
      title: "technicalPage",
      dataIndex: "technicalPage",
      width: "15%",
      render: (value, record) => {
        return <ShowImageWithLink link={value} />
      },
    },
    {
      title: "Start Date",
      dataIndex: "created",
      render: (value) => <>{startDate(value)}</>,
    },

    {
      title: "End Date",
      dataIndex: "completedTime",
      render: (value, record) => <>{endDate(value, record)}</>,
    },
  ]

  if (price.hasDoneOrders) {
    return (
      <>
        <Link onClick={showDrawer}>
          <UnorderedListOutlined /> History
        </Link>
        <Drawer
          placement="bottom"
          title={price.product.productName}
          height={700}
          onClose={onClose}
          open={open}>
          <Table
            size="small"
            columns={tableColumns}
            loading={loading}
            dataSource={orders}
            style={{ padding: 15 }}
            locale={{
              emptyText: "No orders found for this product.",
            }}
            rowKey={(record) => record.id}
          />
        </Drawer>
      </>
    )
  } else {
    return (
      <>
        <Text style={{ color: "red" }}>
          <UnorderedListOutlined /> No History
        </Text>
      </>
    )
  }
}
